import React, { Fragment } from 'react'
import InspectionScreen from '../Inspection/InspectionScreen'

const DashboardLayout = () => {
  return (
    <Fragment>
        <InspectionScreen />
    </Fragment>
  )
}

export default DashboardLayout
